import { Button, Carousel, Tag } from "antd";
import styled from "styled-components";
import { FoundItemCardType } from "../../../types/FoundItemTypes";

export const MatchFoundContainer = styled.div`
  margin-top: 8px;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
`;

export const MatchFoundHeaderContainer = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
`;

export const TrackingNumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  font-size: 14px;


  @media (max-width: 425px) {
    gap: 0px;
  }
`;

export const CourierName = styled.p`
  margin: 0;
  padding: 0;
`;

export const CourierNameText = styled.p`
  margin: 0;
  padding: 0;
`;

export const TrackingNumberText = styled.p`
  margin: 0;
  padding: 0;
`;

export const MatchFoundTitleText = styled.p`
  margin: 0;
  padding: 0;
`;

export const MatchFoundItemsContainer = styled.div`
  width: 98%;
  display: flex;
  gap: 9px;
  padding: 18px 16px 23px;
  overflow-x: scroll;
`;

export const MatchFoundItemWrapper = styled.div`
  min-width: 300px;
  max-width: 300px;
  width: 100%;
  cursor: pointer;
`;

export const MatchFoundTicketWrapper = styled.div<any>`
  border: 1px solid ${({ status }) => status === FoundItemCardType.Found_Item ? "#FFD666" : status === FoundItemCardType.Found_Item_Done ? "#4096FF" : "#F0F0F0"};
  background: ${({ status }) => status === FoundItemCardType.Found_Item ? "#FFFBE6" : status === FoundItemCardType.Found_Item_Done ? "#E6F4FF" : "#FFFFFF"};
  border-radius: 5px;
  /* border: 1px solid ${({ scoreColor, cardType }) => scoreColor && cardType === "MATCHED" ? scoreColor : "#f0f0f0"}; */
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &.selected{
    background: ${({ bgColor }) => bgColor ? bgColor : "#F6FFED"};
    border: 1px solid ${({ scoreColor }) => scoreColor ? scoreColor : "#52C41A"};
    opacity:1;
  }
  
  &.unSelected{
    opacity:0.5;
  }
`;

export const MatchFoundTitleReportId = styled.p`
  color: black;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  margin: 0;
`;

export const MatchFoundHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MatchFoundHeaderLeftContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const MatchFoundBtnWrapper = styled(Button) <{ bgColor?: string }>`
  background-color: ${(props) => props.bgColor || "#04D100"} !important;
  padding: 4px 8px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  color: #ffffff;
  height: 21px;
  
  &:hover,
  &:focus {
    background-color: ${(props) => props.bgColor || "#04D100"} !important;
    color: #ffffff !important;
  }
`;

export const MatchFoundHeaderLeftSub = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MatchFoundTitle = styled.h3`
  margin: 0px;
  font-weight: 600;
  font-size: 16px;
  width: 278px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const MatchFoundSubCategoryTitle = styled.span`
  margin: 0px;
  font-weight: 400 !important;
  font-size: 16px;
`;

export const MatchFoundSubTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0px;
  font-weight: 500;
  color: #000;
  font-size: 12px
`;

export const MatchFoundReportDateMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MatchFoundReportDateWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin: 0;
`;

export const MatchFoundInfo = styled.span`
  font-weight: 500;
  color: #b3b8c1;
  font-size: 12px;
`;

export const MatchFoundInfoText = styled.span`
  font-size: 12px;
  font-weight: 500;
`;

// Carousel

export const StyledCarousel = styled(Carousel)`
  .slick-slide {
    width: 300px !important;
    margin-right: 8px !important;
    height: 176px !important;

    @media (max-width: 1310px) {
      width: auto !important;
      margin: 0 auto !important;
    }

    @media (max-width: 425px) {
      width: auto !important;
      margin: 0 auto !important;
    }
  }

  .slick-track {
    display: flex !important;
  }

  .slick-arrow {
    color: #0d63ff !important;
    top: 40% !important;
  }

  .slick-arrow::after {
    width: 20.313708px !important;
    height: 20.313708px !important;
  }
`;

export const CarouselMainContainer = styled.div`
  padding: 18px 16px 23px;

  @media (max-width: 425px) {
    padding-left: 13px;
    padding-right: 13px;
  }
`;

export const ShipWrapper = styled.div`
  font-size: 14px;
  color: #000;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const InfoText = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #000;
`;

export const ScoreContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const LocationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const AssigneeName = styled(Tag)`
    margin-right: 0;
    border-radius: 16px; 
    padding: 0px 8px;
    font-size: 10px;
    background-color: #ffffff;
    color:#000000;
    height: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    `